import { IDLE } from "../../global/statusLabels"
import { CHECK_SCREENING_MX_SUCCESS, RESET_SCREENING_MAMMOGRAFICO_STATE } from "./actionsType"

const initialState = {
    checkScreeningMX: { value: undefined, status: IDLE },

}

export const screeningMammograficoReducer = (state = initialState, action) => {
    switch (action.type) {

        case CHECK_SCREENING_MX_SUCCESS:
            return {
                ...state,
                checkScreeningMX: action.payload
            }

        case RESET_SCREENING_MAMMOGRAFICO_STATE:
            return initialState

        case 'persist/REHYDRATE':
            return state;

        default:
            return state;
    }
}